var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white",attrs:{"id":"app"}},[_c('div',[_c('section',{class:_vm.animation},[_c('div',{staticClass:"input-fields"},[_c('BookerCreation',{attrs:{"referrer_id":_vm.referrer_id}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }